import { Select } from "common/InputForm";
import useDebounce from "common/UseDebounce";
import { SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { downloadFileApi, userManagementListApi } from "services/user";
import "./userManagement.scss";
import findSerialNumber from "utils/findSerialNumber";
import NotFound from "common/NotFound";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaEdit, FaEye } from "react-icons/fa";

import Pagination from "react-js-pagination";

import { useNavigate } from "react-router-dom";
import { CgBlock, CgUnblock } from "react-icons/cg";
import BlockUnblockUser from "./BlockUnblockUser";
import { CustomModal } from "components/modals/ModalBox";
import { userPlaceholder } from "assets/icons";
import useButtonLoader from "hooks/useButtonLoader";

const UserManagement = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [userDetail, selectedUserDetail] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Export as CSV");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const total = +searchParams.get("total") || 1;
  const status = searchParams.get("status") || "";

  // ------------search related properties
  const search = searchParams.get("search") || "";
  const debouncedValue = useDebounce(search, 300);
  const setSearchFun = (searchTxt) => {
    const newParams = new URLSearchParams(searchParams); // safe copy
    newParams.set("page", 1);
    newParams.set("search", searchTxt);
    setSearchParams(newParams);
  };

  // -----close model

  const closeModel = () => {
    selectedUserDetail({});
    setStatusModal(false);
  };

  //*********Handel Pagination********* */

  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  // ------user fetched data

  const [userListState, setUserListState] = useState([]);

  const fetchUserManagementList = async () => {
    const query = {
      page: activePage,
      limit: limit,
      status,
    };

    onShow();

    if (search && debouncedValue) {
      query.search = debouncedValue;
    }

    try {
      const {
        data: {
          status,
          code,
          data: { total, users },
        },
      } = await userManagementListApi(query);

      // console.log("status,code:--->", status, code);
      // console.log("total,users:--->", total, users);

      if (status || code === 200) {
        const urlResponse = new URLSearchParams(searchParams);
        urlResponse.set("total", total);
        setSearchParams(urlResponse);

        setUserListState(users);
      }
    } catch (error) {
      console.log(error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchUserManagementList();
  }, [debouncedValue, activePage, limit, status]);

  // -------------show image model

  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  // show image preview handler
  const showImagePreviewHandler = (profile) => {
    if (profile) {
      setShowImagePreviewModel(true);
      setImagePreview(profile);
    }
  };
  // -----------download-File-Api----------------
  const downloadFileHandler = async () => {
    try {
      setButtonLoader(true);
      const param = {
        search: debouncedValue || '',
        page: activePage,
        limit,
        status,
      };
      const response = await downloadFileApi(param);
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'user.xlsx'); // Change filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log("Download user file error: ", error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="user-management-container">
      <div className="page_title has_child">
        <h3>User Management</h3>
        <div className="tabContainer">
          <button
            className="button"
            type="button"
            ref={buttonLoader}
            onClick={downloadFileHandler}
          >
            Export as CSV
          </button>
        </div>
      </div>
      {/* -search wrapper */}
      <div className="search_wrapper-option-selector">
        <SearchBar
          onKeyDown={(e) => {
            const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
            const controlKeys = [
              "Backspace",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
              "Tab",
              "Escape",
            ];

            // Allow letters, numbers, space, hyphen
            if (allowedKeysRegex.test(e.key) || controlKeys.includes(e.key)) {
              return;
            }

            // Block everything else
            e.preventDefault();
          }}
          placeholder={"Search..."}
          onChange={(e) => setSearchFun(e.target.value)}
          value={search}
        />

        <Select
          onChange={(e) => {
            const urlInstance = new URLSearchParams(searchParams);
            urlInstance.set("status", e.target.value);
            setSearchParams(urlInstance);
          }}
          value={status}
          className="select-opt"
        >
          {[
            { value: "", title: "All Status" },
            { value: "ACTIVE", title: "Active" },
            { value: "BLOCKED", title: "Blocked" },
            { value: "DELETED", title: "Deleted" },
            { value: "INACTIVE", title: "Inactive" },

          ].map((statusProp, ind) => (
            <option key={ind} value={statusProp.value}>
              {statusProp.title}
            </option>
          ))}
        </Select>

      </div>

      {/* ---------card */}
      <div className="card">
        {loader}
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">C.ID</th>
                <th className="nowrap text-center">Profile </th>
                <th className="nowrap text-center">Name</th>
                <th className="nowrap text-center">Date of Birth</th>
                <th className="nowrap text-center">Mobile number</th>
                <th className="nowrap text-center">Email</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {userListState.length > 0 ? (
                userListState?.map((mapProp, index) => {
                  return (
                    <tr key={index} onClick={() => {
                            navigate(
                                `/user-management/details/${mapProp?._id}`
                              );
                          }}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, limit)}
                      </td>

                      <td className="nowrap text-center"  onClick={(e) => {
    e.stopPropagation();
    // your logic here
  }}>
                        {mapProp?.customerId || "---"}
                      </td>

                      <td className="nowrap text-center">
                        <div className="td-img">
                          <img
                            src={mapProp?.image || userPlaceholder}
                            alt={mapProp?.fullName}
                            onClick={() =>
                              showImagePreviewHandler(mapProp?.image)
                            }
                          />
                        </div>
                      </td>

                      <td className="nowrap text-center">
                        {mapProp?.fullName || "---"}
                      </td>

                      <td className="nowrap text-center">
                        {mapProp?.dob || "---"}
                      </td>

                      <td className="nowrap text-center">
                        {mapProp?.countryCode && mapProp?.phone ? (
                          <div>
                            <span>{mapProp?.countryCode}</span>{" "}
                            <span>{mapProp?.phone}</span>
                          </div>
                        ) : (
                          "---"
                        )}
                      </td>
                      <td className="nowrap text-center">
                        {mapProp?.email || "---"}
                      </td>

                      <td className="nowrap text-center">
                        <div className="button-container">
                          <button
                            onClick={() => {
                              navigate(
                                `/user-management/details/${mapProp?._id}`
                              );
                            }}
                          >
                            {/* <FaEye /> */}
                            <FaEdit />
                          </button>

                          {/* <button
                            type="button"
                            onClick={() => {
                              selectedUserDetail(mapProp);
                              setStatusModal(true);
                            }}
                            disabled={mapProp?.status === "DELETED"}
                          >
                            {mapProp?.status === "BLOCKED" ? (
                              <CgBlock style={{ color: "red" }} />
                            ) : (
                              <CgUnblock />
                            )}
                          </button> */}


                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={7}
                  msg={"Brand data not found"}
                  onHide={onHide}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ------------------Change User Status*/}
      {statusModal && (
        <BlockUnblockUser
          selectedUserDetail={userDetail}
          onClose={() => closeModel()}
          fetchUserManagementList={fetchUserManagementList}
          statusModal={statusModal}
        />
      )}

      {showImagePreviewModel && (
        <CustomModal
          className={"sm image_preview_modal"}
          show={showImagePreviewModel}
          handleClose={() => {
            setImagePreview("");
            setShowImagePreviewModel(false);
          }}
        >
          <div className="image_preview">
            <img
              src={imagePreview || userPlaceholder}
              alt="user-profile-preview"
            />
          </div>
        </CustomModal>
      )}

      {/* ------pagination */}

      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
